"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHelmet = require("react-helmet");
var _SEOData = require("./SEOData");
var _Schema = require("./Schema");
var _AnalyticsData = require("./AnalyticsData");
var _siteHelper = require("../../../lib/siteHelper");
var _globalDataContext = _interopRequireDefault(require("../../../lib/globalDataContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var FinproHeadTags = props => {
  var pageUrl = (0, _siteHelper.pageUri)({
    pagePath: props.metadata.pagePath
  });
  var env = _globalDataContext.default.env === 'preview' ? 'prod' : _globalDataContext.default.env === 'fb' ? 'dev' : _globalDataContext.default.env;
  var [seoData, utagData, schemaData] = function () {
    switch (props.pageType) {
      case 'agent':
        return [(0, _SEOData.agentSEOData)(props.metadata), (0, _AnalyticsData.agentUtagData)(props.metadata, env), (0, _Schema.agentSchema)(props.metadata, pageUrl)];
      case 'agency':
        return [(0, _SEOData.agencySEOData)(props.metadata), (0, _AnalyticsData.agencyUtagData)(props.metadata, env), (0, _Schema.agencySchema)(props.metadata, pageUrl)];
      case 'city':
        return [(0, _SEOData.citySEOData)(props.metadata), (0, _AnalyticsData.cityUtagData)(props.metadata, env), null];
      case 'state':
        return [(0, _SEOData.stateSEOData)(props.metadata), (0, _AnalyticsData.stateUtagData)(props.metadata, env), null];
      case 'country':
        return [(0, _SEOData.countrySEOData)(), (0, _AnalyticsData.countryUtagData)(env), null];
      default:
        return [(0, _SEOData.defaultSEOData)(), null, null];
    }
  }();
  var tealiumParam = {
    env: env,
    app: _globalDataContext.default.appName,
    pageQuery: props.metadata.pageQuery,
    addUtagLoginCookie: props.metadata.addUtagLoginCookie,
    utagSiteName: props.metadata.utagSiteName,
    initialUtags: utagData
  };
  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, seoData.title), /*#__PURE__*/_react.default.createElement("meta", {
    name: "title",
    content: seoData.title
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: seoData.description
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: seoData.titleOG
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: seoData.descriptionOG
  }), seoData.city && /*#__PURE__*/_react.default.createElement("meta", {
    name: "city",
    content: "".concat(props.metadata.location.city, ", ").concat(props.metadata.location.stateName)
  }), seoData.state && /*#__PURE__*/_react.default.createElement("meta", {
    name: "state",
    content: "".concat(props.metadata.location.state, ", ").concat(props.metadata.location.stateName)
  }), seoData.city && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:locality",
    content: props.metadata.location.city
  }), seoData.state && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:region",
    content: props.metadata.location.stateName
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:country-name",
    content: 'US'
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:site_name",
    content: 'MassMutual'
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: 'website'
  }), /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: pageUrl
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "google-site-verification",
    content: "AH5-y5aY7CuOFuEEFZ3-pXtpFY3_XO605Gct27t4qVs"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: pageUrl
  }), schemaData && /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json"
  }, "".concat(JSON.stringify(schemaData))), utagData && /*#__PURE__*/_react.default.createElement("script", {
    type: "application/ld+json",
    src: "//tags.tiqcdn.com/utag/massmutual/main/".concat(env, "/utag.sync.js")
  }), utagData && /*#__PURE__*/_react.default.createElement("script", {
    src: "/dist/js/tealiumTagging.js",
    type: "text/javascript",
    "data-args": JSON.stringify((0, _siteHelper.tealiumTags)(tealiumParam))
  }));
};
var _default = exports.default = FinproHeadTags;